var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.vertical ? 'mx-3' : 'my-3'},[_c('v-divider',{staticClass:"line-border",staticStyle:{"border-radius":"15%"},style:({ width: _vm.long, 'border-width': _vm.borderWidthAdditional }),attrs:{"vertical":_vm.vertical}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }